module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-10.66b6e88b.jpg";